module.exports = __webpack_public_path__ + "img/Group1000005850@2x.0ebb75d0.webp";